@if (currentViewType === viewType.Mobile) {
	@defer {
		<app-catalog-mobile />
	}
} @else {
	@defer {
		<app-catalog-desktop />
	}
}
